import { map } from 'lodash-es';
import {
	CANCELED_ORDER_MESSAGE,
	COMPLETED_ORDER_MESSAGE,
	OPEN_ORDER_MESSAGE,
	REJECTED_ORDER_MESSAGE,
} from '../../../constants/equity/orderBook/orderBookLanding';
import { TRANSACTION_TYPES } from '../../../constants/equity/common';
import { ORDER_TYPES } from '../../../constants/equity/orderForm/oneTime';

function getOrderStatusBarColor(friendlyStatus = '') {
	let color = 'secondary.mango';
	if (friendlyStatus === 'COMPLETED') {
		color = 'secondary.profitGreen';
	} else if (
		friendlyStatus === 'CANCELLED' ||
		friendlyStatus === 'REJECTED'
	) {
		color = 'secondary.lossRed';
	}

	return {
		indicatorColorKey: `${color}.400`,
		backgroundColorKey: `${color}.200`,
	};
}

function getOrderStatusDotColorKey(friendlyStatus) {
	let color = 'secondary.mango.400';
	if (friendlyStatus === 'COMPLETED') {
		color = 'secondary.profitGreen.400';
	} else if (friendlyStatus === 'CANCELLED') {
		color = 'secondary.lossRed.400';
	} else if (friendlyStatus === 'REJECTED') {
		color = 'secondary.lossRed.400';
	}

	return color;
}

function getOrderStatusBarUiConfig(friendlyStatus, rejectionReason = '') {
	const finalConfig = getOrderStatusBarColor(friendlyStatus);

	if (friendlyStatus === 'COMPLETED') {
		finalConfig.message = COMPLETED_ORDER_MESSAGE;
		finalConfig.isCompletedOrder = true;
	} else if (friendlyStatus === 'CANCELLED') {
		finalConfig.message = CANCELED_ORDER_MESSAGE;
		finalConfig.isCanceledOrder = true;
	} else if (friendlyStatus === 'REJECTED') {
		finalConfig.message = rejectionReason
			? `${REJECTED_ORDER_MESSAGE}: ${rejectionReason}`
			: REJECTED_ORDER_MESSAGE;
		finalConfig.isRejectedOrder = true;
	} else {
		finalConfig.message = OPEN_ORDER_MESSAGE;
		finalConfig.isOpenOrder = true;
	}

	return finalConfig;
}

function isBuyOrder(transactionType) {
	return transactionType === TRANSACTION_TYPES.BUY;
}

function getColorFromTransactionType(transactionType) {
	return isBuyOrder(transactionType)
		? 'secondary.profitGreen.400'
		: 'secondary.lossRed.400';
}

function getTransactionTypeUiConfig(transactionType, orderType) {
	const finalData = { color: getColorFromTransactionType(transactionType) };

	switch (orderType) {
		case ORDER_TYPES.market.value:
			finalData.transactionTypeLabel = transactionType;
			finalData.isMarketOrder = true;
			break;
		case ORDER_TYPES.limit.value:
			finalData.transactionTypeLabel = transactionType;
			finalData.isLimitOrder = true;
			break;
		case ORDER_TYPES.stoploss.value:
			finalData.transactionTypeLabel = `${transactionType} ${ORDER_TYPES.stoploss.name}`;
			finalData.isStopLossOrder = true;
			break;
		case ORDER_TYPES.stoplossMarket.value:
			finalData.transactionTypeLabel = `${transactionType} ${ORDER_TYPES.stoplossMarket.name}`;
			finalData.isStopLossMarketOrder = true;
			break;
		default:
			finalData.transactionTypeLabel = '';
	}

	return finalData;
}

function getSearchResultsCountString(len) {
	const text = `${len} Order${len > 1 ? 's' : ''}`;
	return text;
}

function getCancelOrdersPayload(selectedOrders, cancelAll) {
	const payload = { flag: false };
	if (cancelAll) {
		payload.flag = true;
		return payload;
	}
	payload.orders = map(selectedOrders, (order) => [
		order.exchange,
		order.order_id,
	]);
	return payload;
}

function getEmptyStateConfig(isOpenList) {
	const title = isOpenList ? 'No open orders' : 'No orders executed';
	const subtitle = isOpenList
		? 'When you place an order, you will be able to view & manage them from here'
		: 'When you place an order, you will be able to view & manage them from here';

	return { title, subtitle };
}

const orderBookLandingService = {
	getOrderStatusBarColor,
	isBuyOrder,
	getColorFromTransactionType,
	getOrderStatusBarUiConfig,
	getTransactionTypeUiConfig,
	getSearchResultsCountString,
	getCancelOrdersPayload,
	getOrderStatusDotColorKey,
	getEmptyStateConfig,
};

export default orderBookLandingService;
